export const getClientSubscriptionTypeLabel = (subscriptionType) => {
    if (
        subscriptionType === 1 ||
        subscriptionType === "1" ||
        subscriptionType === "Subscription" ||
        subscriptionType === "subscription"
    ) {
        return "Subscription";
    }

    if (
        subscriptionType === 2 ||
        subscriptionType === "2" ||
        subscriptionType === "NonSubscription" ||
        subscriptionType === "nonsubscription" ||
        subscriptionType === "Non-subscription" ||
        subscriptionType === "non-subscription"
    ) {
        return "Non-subscription";
    }

    return null;
};
